import _axios from "@/axios";
import { reactive, ref } from "@vue/composition-api";
import { showSnackBar } from "@/composables/snackbar";
import { handleFormErrors } from "@/composables/form-error";

const attributes = ref([]);
const macaddresses = ref([]);

export function useAttributes() {
  const attributeData = reactive({
    attributeForm: {},
    macAddressAttributeFormRef: null,
    attributeFormRef: null,
    rules: {
      valueRules: [(v) => !!v || "Champ obligatoire"],
    },
    createAttributeDialog: false,
    editAttributeDialog: false,
    createMacAdressAttributeDialog: false,
    firstLoad: true,
    isLoading: false,
    attributesChoice: [
      "ACCESS-LIST",
      "USE-ACCESS-LIST",
      "SSL-CERTIFICATE",
      "CONFIGURATION-FILE",
      //'MAC-ADDRESS',
      "DEFAULT-USER-ACCT-INTERIM-UPDATE",
      "DEFAULT-USER-MAX-INPUT-PACKETS",
      "DEFAULT-USER-MAX-OUTPUT-PACKETS",
      "DEFAULT-USER-MAX-INPUT-OCTETS",
      "DEFAULT-USER-MAX-OUTPUT-OCTETS",
      "DEFAULT-USER-IDLE-TIMEOUT",
      "DEFAULT-USER-BANDWIDTH-LEVEL",
      //'DEFAULT-USER-SMTP-REDIRECT',
      "DEFAULT-USER-SESSION-TIMEOUT",
      "DEFAULT-USER-ONE-TO-ONE-NAT",
      "LOGIN-PAGE",
      "TRANSPORT-PAGE",
      "SESSION-PAGE",
      "FAIL-PAGE",
      "LOGO",
      "MESSAGES",
      "REDIRECT-PAGE",
      "WELCOME-URL",
      "GOODBYE-URL",
      "LOGIN-ERR-URL",
      "LOGIN-URL",
      "SSL-NOC-CERTIFICATE",
      "SSL-NOC-CA-CERTIFICATE",
      "IPASS-LOGIN-URL",
      "COLUBRIS-WISPR-ACCESS-PROCEDURE",
      "COLUBRIS-WISPR-LOGIN-URL",
      "COLUBRIS-WISPR-ABORT-LOGIN-URL",
      "WISPR-LOCATION-ID",
      "WISPR-LOCATION-NAME",
      "WISPR-LOGOFF-URL",
      //'HTTP-Proxy-Upstream',
      "DNAT-SERVER",
      "UHHI-HEADER-CONTENT",
    ],
    attributesChoiceData: {
      "ACCESS-LIST": [
        1,
        "listname[,OPTIONAL],action,protocol,address,port[,account[,interval]]",
        "---",
      ],
      "USE-ACCESS-LIST": [0, "listname", "---"],
      "USE-ACCESS-LIST-UNAUTH": [0, "listname", "---"],
      "SSL-CERTIFICATE": [
        0,
        "URL[placeholder]",
        "%s The login name assigned to the controller<br/>%n The NAS ID assigned to the controller",
      ],
      "CONFIGURATION-FILE": [
        0,
        "URL[placeholder]",
        "%s The login name assigned to the controller<br/>%n The NAS ID assigned to the controller",
      ],
      "MAC-ADDRESS": [1, "address[,username,[,password]]", "---"],
      "DEFAULT-USER-ACCT-INTERIM-UPDATE": [0, "value", "---"],
      "DEFAULT-USER-BANDWIDTH-LEVEL": [0, "VERY-HIGH|HIGH|NORMAL|LOW", "---"],
      "DEFAULT-USER-MAX-INPUT-PACKETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-OUTPUT-PACKETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-TOTAL-PACKETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-INPUT-OCTETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-OUTPUT-OCTETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-TOTAL-OCTETS": [0, "value", "---"],
      "DEFAULT-USER-MAX-INPUT-RATE": [0, "value", "---"],
      "DEFAULT-USER-MAX-OUTPUT-RATE": [0, "value", "---"],
      "DEFAULT-USER-IDLE-TIMEOUT": [0, "seconds", "---"],
      "DEFAULT-USER-USE-ACCESS-LIST": [0, "uselistname", "---"],
      "DEFAULT-USER-SMTP-REDIRECT": [
        0,
        "hostname[:port][,username,password]",
        "---",
      ],
      "DEFAULT-USER-WELCOME-URL": [
        0,
        "URL_of_page[placeholder]",
        "%d Returns the WISPr location-ID. Supported for login-url only.<br/>" +
          "%e Returns the WISPr location-Name. Supported for login-url only.<br/>" +
          "%l Returns the URL on the MSC where customer login information should be posted for authentication. This option is used with the remote login page feature. By default, this value is URL encoded. (To enabledisable URL encoding, set the value of url-encode in the section in the configuration file.)<br/>" +
          "%n Returns the NAS ID assigned to the MSC. By default, this is the unit\u2019s serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the MSC. By default, this is the unit\u2019s serial number.<br/>" +
          "%u Returns the login name of the customer. %o Returns the original URL requested by the customer. By default, this value is URL encoded. (To enabledisable URL encoding, set the value of url-encode in the section in the configuration file.)<br/>" +
          "%i Returns the domain name assigned to the MSC\u2019s Internet port. %p Returns the IP port number on the MSC where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the MSC\u2019s Internet port.<br/>" +
          "%E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode (ieee802.11a, ieee802.11b, ieee802.11g) the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-station-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature. The information contained in the returned string depends on the configuration of the RADIUS server.<br/>" +
          "%m Returns the MAC address of the client station that is being authenticated. %v Returns the VLAN assigned to the client station at the MSC\u2019s ingress (LAN port).",
      ],
      "DEFAULT-USER-SESSION-TIMEOUT": [0, "seconds", "---"],
      "DEFAULT-USER-ONE-TO-ONE-NAT": [
        0,
        "value (Set to 1 to activate one-to-one NAT support)",
        "---",
      ],
      "DEFAULT-USER-USE-PUBLIC-IP-SUBNET": [
        0,
        "value (Set to 1 to activate use-public-ip-subnet support)",
        "---",
      ],
      "PRIMARY-WEB-SERVER-STATUS-URL": [0, "URL_of_status_page", "---"],
      "SECONDARY-WEB-SERVER-STATUS-URL": [0, "URL_of_status_page", "---"],
      "PRIMARY-DNAT-SERVER-STATUS-URL": [
        0,
        "listname, URL_of_status_page",
        "---",
      ],
      "SECONDARY-DNAT-SERVER-STATUS-URL": [
        0,
        "listname, URL_of_status_page",
        "---",
      ],
      "HTTP-PROXY-UPSTREAM": [0, "hostname[:port]", "---"],
      "LOGIN-PAGE": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "TRANSPORT-PAGE": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "SESSION-PAGE": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "FAIL-PAGE": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      LOGO: [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      MESSAGES: [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "CUSTOM-PAGES": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "REDIRECT-PAGE": [
        0,
        "URL_of_page",
        "(optional) (not available in local mode)<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.",
      ],
      "WELCOME-URL": [
        0,
        "URL_of_page[placeholder]",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request. %E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "GOODBYE-URL": [
        0,
        "URL_of_page[placeholder]",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request. %E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "LOGIN-ERR-URL": [
        0,
        "URL_of_page[placeholder]",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request. %E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "LOGIN-URL": [
        0,
        "URL_of_page[placeholder]",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request. %E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "REDIRECT-URL": [
        0,
        "URL_of_page[placeholder]",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request. %E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "SSL-NOC-CERTIFICATE": [0, "URL_of_the_certificate", "---"],
      "SSL-NOC-CA-CERTIFICATE": [0, "URL_of_the_certificate", "---"],
      "IPASS-LOGIN-URL": [0, "URL_of_page", "---"],
      "VSA-WISPR-ACCESS-PROCEDURE": [0, "Procedure version", "---"],
      "VSA-WISPR-LOGIN-URL": [0, "URL_of_page", "---"],
      "VSA-WISPR-ABORT-LOGIN-URL": [0, "URL_of_page", "---"],
      "WISPR-LOCATION-ID": [0, "Location id.", "---"],
      "WISPR-LOCATION-NAME": [0, "User readable location name.", "---"],
      "WISPR-LOGOFF-URL": [0, "Site specific logoff URL.", "---"],
      "DNAT-SERVER": [
        0,
        "listname, address, port[,secondary_hostname,secondary_port]",
        "---",
      ],
      "UHHI-HEADER-CONTENT": [
        0,
        "Content of UserInfo Header",
        "%c Returns the IP address of the customer's computer.<br/>" +
          "%l Returns the URL on the controller where customer login information should be posted for authentification. This option is used with the remot login page feature.<br/>" +
          "%n Returns the NAS ID assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%s Returns the RADIUS login name assigned to the controller. By default, this is the unit's serial number. Not supported in local mode.<br/>" +
          "%u Returns the login name of the customer.<br/>" +
          "%o Returns the original URL requested by the customer.<br/>" +
          "%i Returns the domain name assigned to the controller's Internet port.<br/>" +
          "%p Returns the IP port number on the controller where customer login information should be posted for authentication.<br/>" +
          "%a Returns the IP address of the controller's interface that is sending the authentication request.<br/>" +
          "%E When the location-aware feature is enabled, returns the ESSID of the wireless access point the customer is associated with.<br/>" +
          "%P When the location-aware feature is enabled, returns the wireless mode('ieee802.11a','ieee802.11b','ieee802.11g')the customer is using to communicate with the access point.<br/>" +
          "%G When the location-aware feature is enabled, returns the group name of the wireless access point the customer is associated with.<br/>" +
          "%C When the location-aware feature is enabled, returns the Called-stations-id content for the wireless access point the customer is associated with.<br/>" +
          "%r Returns the string sent by the RADIUS server when an authentication request fails. The RADIUS server must be configured to support this feature.<br/>" +
          "%m Returns the Calling-station-id content for the wireless access point the customer is associated with.",
      ],
      "": [null, null, null],
    },
  });

  function listAttributes(clientId = null, name = null, partnerId = null) {
    attributeData.isLoading = true;
    const params = new URLSearchParams({});
    let routePath = "";
    if (clientId != null) {
      routePath = "/list-attribute/portal/" + clientId;
    } else if (partnerId != null) {
      routePath = "/list-attribute/partner/" + partnerId;
    }
    if (name != null) {
      params.set("name", name);
    }

    return _axios
      .get(routePath + "?" + params.toString())
      .then((response) => {
        if (name == "MAC-ADDRESS") {
          macaddresses.value = response.data.data;
        } else {
          attributes.value = response.data.data;
        }
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        attributeData.firstLoad = false;
        attributeData.isLoading = false;
        attributeData.attributeForm = {};
      });
  }

  function createAttribute(clientId) {
    attributeData.isLoading = true;
    attributeData.createAttributeDialog = true;
    if (attributeData.attributeFormRef != null) {
      const isValid = attributeData.attributeFormRef.validate();
      if (!isValid) {
        attributeData.isLoading = false;
        return;
      }
    }

    attributeData.attributeForm.client = clientId;

    return _axios
      .post("/create-attribute", attributeData.attributeForm)
      .then(() => {
        attributeData.createAttributeDialog = false;
        listAttributes(clientId);

        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          attributeData.rules,
          attributeData.attributeFormRef
        );
      })
      .finally(() => {
        attributeData.isLoading = false;
      });
  }

  function createMacAddressAttribute(clientId) {
    attributeData.isLoading = true;
    attributeData.createMacAdressAttributeDialog = true;
    if (attributeData.macAddressAttributeFormRef != null) {
      const isValid = attributeData.macAddressAttributeFormRef.validate();
      if (!isValid) {
        attributeData.isLoading = false;
        return;
      }
    }

    attributeData.attributeForm.client = clientId;

    return _axios
      .post("/create-mac-address-attribute", attributeData.attributeForm)
      .then(() => {
        listAttributes(clientId, "MAC-ADDRESS");
        attributeData.createMacAdressAttributeDialog = false;
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          attributeData.rules,
          attributeData.macAddressAttributeFormRef
        );
      })
      .finally(() => {
        attributeData.isLoading = false;
      });
  }

  function updateAttribute(attribute, name = null) {
    attributeData.isLoading = true;
    attributeData.editAttributeDialog = true;
    if (attributeData.attributeFormRef != null) {
      const isValid = attributeData.attributeFormRef.validate();
      if (!isValid) {
        attributeData.isLoading = false;
        return;
      }
    }

    return _axios
      .put("/attribute/" + attribute.id, attributeData.attributeForm)
      .then((response) => {
        const attributeUpdated = response.data.data;
        if (name != null && attributeUpdated.client != null) {
          attributeData.editAttributeDialog = false;
          listAttributes(attributeUpdated.client.id, name);
        } else if (attributeUpdated.client != null) {
          attributeData.editAttributeDialog = false;
          listAttributes(attributeUpdated.client.id);
        } else {
          listAttributes(null, null, attributeUpdated.partner.id);
        }
        showSnackBar();
      })
      .catch((error) => {
        const formErrors = error.response.data.violations;
        handleFormErrors(
          formErrors,
          attributeData.rules,
          attributeData.attributeFormRef
        );
      })
      .finally(() => {
        attributeData.isLoading = false;
      });
  }

  function deleteAttribute(
    attribute,
    name = null,
    clientPortal = null,
    partner = null
  ) {
    return _axios
      .delete("/attribute/" + attribute.id)
      .then(() => {
        if (name != null && clientPortal != null) {
          attributeData.editMacAdressAttributeDialog = false;
          listAttributes(clientPortal.id, name);
        } else if (clientPortal != null) {
          attributeData.editAttributeDialog = false;
          listAttributes(clientPortal.id);
        } else if (partner != null) {
          listAttributes(null, null, partner.id);
        }
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    attributes,
    macaddresses,
    listAttributes,
    createAttribute,
    attributeData,
    updateAttribute,
    deleteAttribute,
    createMacAddressAttribute,
  };
}
